import { render } from "./SurveyQ5Faq.vue?vue&type=template&id=838a2068&ts=true"
import script from "./SurveyQ5Faq.vue?vue&type=script&lang=ts"
export * from "./SurveyQ5Faq.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__